import React from 'react';
import { useUpdateProjectAvatar } from '../services/update-project-avatar/index.tsx';
import { NavigationKitAvatarPopup } from './navigation-kit-avatar-popup/NavigationKitAvatarPopup.tsx';

type NavigationKitAvatarProps = {
	projectId: number;
	selectedAvatarUrl: string;
	canEdit: boolean;
};

export const NavigationKitAvatar = ({
	projectId,
	selectedAvatarUrl,
	canEdit,
}: NavigationKitAvatarProps) => {
	const { systemAvatars, latestCustomAvatar, updateProjectAvatar, uploadProjectAvatar } =
		useUpdateProjectAvatar(projectId, selectedAvatarUrl);

	return (
		<NavigationKitAvatarPopup
			selectedAvatarUrl={selectedAvatarUrl}
			systemAvatars={systemAvatars}
			latestCustomAvatar={latestCustomAvatar}
			onSelectAvatar={updateProjectAvatar}
			onUploadAvatar={uploadProjectAvatar}
			canEdit={canEdit}
		/>
	);
};
